var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStableDiaryNewEntry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "stable_diary_new_entry") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.59,
    y: 0.97,
    width: 600,
    height: 600,
    fill: "none",
    opacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "stable_diary_new_entry"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 300,
    r: 299.05,
    fill: "#00a0df"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.86,244.72h-90v-84.9A56,56,0,0,0,301,104h0a56,56,0,0,0-55.85,55.85v84.9H165.25a56,56,0,0,0-55.85,55.85h0a56,56,0,0,0,55.85,55.85h79.92v85A56,56,0,0,0,301,497.27h0a56,56,0,0,0,55.85-55.85v-85h90a56,56,0,0,0,55.85-55.85h0A56,56,0,0,0,446.86,244.72Z",
    fill: "#ccf2ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStableDiaryNewEntry);
export default __webpack_public_path__ + "static/media/stable_diary_new_entry.4604fbe619d8a22ac7aac0bd9a4c3b86.svg";
export { ForwardRef as ReactComponent };